import { hasPermission, type Role } from "./permissions";

const ID = "[A-Za-z0-9_-]+";

/** Pages a reception user may open. Everything else returns to the inbox. */
export function receptionPathAllowed(pathname: string): boolean {
  return (
    pathname === "/inbox" ||
    pathname === "/lead/new" ||
    pathname === "/tasting" ||
    new RegExp(`^/inbox/${ID}$`).test(pathname) ||
    new RegExp(`^/lead/${ID}$`).test(pathname) ||
    new RegExp(`^/tasting/${ID}$`).test(pathname) ||
    new RegExp(`^/events/${ID}/tasting$`).test(pathname)
  );
}

const RECEPTION_API: readonly { method: string; pattern: RegExp }[] = [
  { method: "GET", pattern: /^\/api\/auth\/me$/ },
  { method: "POST", pattern: /^\/api\/auth\/logout$/ },
  { method: "GET", pattern: /^\/api\/inquiries$/ },
  { method: "GET", pattern: new RegExp(`^/api/inquiries/${ID}$`) },
  { method: "GET", pattern: /^\/api\/venues$/ },
  { method: "GET", pattern: /^\/api\/tastings\/lookup$/ },
  { method: "GET", pattern: /^\/api\/tastings$/ },
  { method: "GET", pattern: /^\/api\/tastings\/open$/ },
  { method: "GET", pattern: /^\/api\/tastings\/conflicts$/ },
  { method: "GET", pattern: /^\/api\/tastings\/suggestions$/ },
  { method: "POST", pattern: /^\/api\/tastings$/ },
  { method: "GET", pattern: new RegExp(`^/api/tastings/${ID}$`) },
  { method: "PATCH", pattern: new RegExp(`^/api/tastings/${ID}$`) },
  { method: "POST", pattern: new RegExp(`^/api/tastings/${ID}/archive$`) },
  { method: "POST", pattern: new RegExp(`^/api/tastings/${ID}/attendance$`) },
  { method: "POST", pattern: new RegExp(`^/api/tastings/${ID}/thanks/send$`) },
  { method: "GET", pattern: new RegExp(`^/api/tastings/${ID}/contract$`) },
  { method: "PUT", pattern: new RegExp(`^/api/tastings/${ID}/contract$`) },
  { method: "POST", pattern: new RegExp(`^/api/tastings/${ID}/contract/send$`) },
  { method: "GET", pattern: new RegExp(`^/api/tastings/${ID}/guests$`) },
  { method: "PUT", pattern: new RegExp(`^/api/tastings/${ID}/guests$`) },
  { method: "POST", pattern: new RegExp(`^/api/tastings/${ID}/guests/send$`) },
  { method: "GET", pattern: new RegExp(`^/api/tastings/${ID}/emails$`) },
  { method: "GET", pattern: new RegExp(`^/api/events/${ID}$`) },
];

/** API calls the inbox, the new-event card, and the tasting form actually make. */
export function receptionRequestAllowed(method: string, pathname: string): boolean {
  return RECEPTION_API.some((entry) => entry.method === method.toUpperCase() && entry.pattern.test(pathname));
}

/** Studio configuration pages: Χώροι, Τιμές, Μεταβλητές, Ροή, Εισαγωγή, Κατάλογος, Ρυθμίσεις. Only superadmin opens them. */
export const CONFIG_PATHS = ["/venues", "/rates", "/variables", "/process", "/imports", "/catalogue", "/settings"] as const;

export function isConfigPath(pathname: string): boolean {
  return CONFIG_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}

export function canOpenConfig(user: { role: Role; permissions?: string[] | null }): boolean {
  return hasPermission(user.role, user.permissions, "config.read");
}
